import { createColumnHelper } from '@tanstack/react-table'

import styles from './RedemptionsTable.module.scss'

import { RedemptionListItem } from '@/api/generated'
import DataTable from '@/components/DataTable'
import { compactAmPm } from '@/utils/compactAmPm'

const columnHelper = createColumnHelper<RedemptionListItem>()

const columns = [
  columnHelper.accessor('user_id', {
    header: 'User ID',
    cell: (info) => (
      <span className={styles.truncatedText} title={info.getValue()}>
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor('code_string', {
    header: 'Code',
    sortingFn: 'alphanumeric',
  }),
  columnHelper.accessor('outcome', {
    header: 'Outcome',
    cell: (info) => {
      const redemptionOutcome = info.getValue()
      const outcomeClass = redemptionOutcome === 'applied' ? styles.outcomeApplied : styles.outcomeFailed
      return <span className={`${styles.outcomeBadge} ${outcomeClass}`}>{redemptionOutcome}</span>
    },
  }),
  columnHelper.accessor('trial_days_granted', {
    header: 'Trial Days',
    cell: (info) => info.getValue() ?? '-',
  }),
  columnHelper.accessor('stripe_subscription_id', {
    header: 'Stripe Sub',
    cell: (info) => {
      const stripeSubId = info.getValue()
      return stripeSubId ? (
        <span className={styles.truncatedText} title={stripeSubId}>
          {stripeSubId}
        </span>
      ) : (
        '-'
      )
    },
  }),
  columnHelper.accessor('created_at', {
    header: 'Date',
    cell: (info) => compactAmPm(new Date(info.getValue()).toLocaleString()),
    sortingFn: 'datetime',
  }),
]

interface RedemptionsTableProps {
  redemptions: RedemptionListItem[]
  isLoading: boolean
}

const RedemptionsTable = ({ redemptions, isLoading }: RedemptionsTableProps) => (
  <DataTable
    data={redemptions}
    columns={columns}
    isLoading={isLoading}
    emptyMessage="No redemptions yet."
    loadingMessage="Loading redemptions..."
    ariaLabel="Promo redemptions"
  />
)

export default RedemptionsTable
